export default __webpack_public_path__ + "static/media/Picasso_Q1_2021_Market_Report.40711e27.pdf";